import m from "./../../../dist/es2015/locales/hu_HU.js";
export const am5locales_hu_HU = m;